import React, { useEffect, useState } from 'react'
import './MapComponents/map.css'
import { MapContainer, TileLayer } from 'react-leaflet'
import { LocationMarker } from './MapComponents/LocationMarker'
import { JobsMarkers } from './MapComponents/JobsMarkers'

export const Map = () => {

    const [position, setPosition] = useState(null)

    useEffect(() => {
        navigator.geolocation.getCurrentPosition(function (position) {
            setPosition({ lat: position.coords.latitude, lng: position.coords.longitude });
        });
    }, [])

    return (
        <MapContainer center={[-33.45694, -70.64827]} zoom={7} className="eight columns">
            <TileLayer
                attribution='Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>'
                // url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                url="https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1Ijoiam9zZXZhc3F1ZWV6IiwiYSI6ImNrcHppdzM4YjA0Zm4ydW8wZm1oaDVsMWgifQ.5Su_ql4cLqySmGces9NutQ"
            />
            <LocationMarker position={position} />
            <JobsMarkers />
        </MapContainer>
    )
}